export default {
	children: {
		notFound: {
			path: "/404",
			meta: { bcText: "404 - Page Not Found" },
			component: () => import(
				/* webpackChunkName: "404" */
				"@/pages/404"
			)
		},

		// Catch-all redirect
		catch: {
			path: "*",
			redirect: { name: "notFound" }
		}
	}
};
